import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../Errors/factory.js'
import UserRepositoriesFactory from '../Repositories/factory.js'
import UserServicesFactory from '../Services/factory.js'

class DeleteAccountUserUseCase extends UseCase {
  #httpUserRepository
  #getCurrentUserService
  #userNotLoggedInUserErrorFactory

  constructor({httpUserRepository, getCurrentUserService, userNotLoggedInUserErrorFactory}) {
    super()
    this.#httpUserRepository = httpUserRepository
    this.#getCurrentUserService = getCurrentUserService
    this.#userNotLoggedInUserErrorFactory = userNotLoggedInUserErrorFactory
  }

  @tracer({metric: 'DeleteAccountUserUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    const userEntity = await this.#getCurrentUserService.execute()
    if (!userEntity || !userEntity.getId()) {
      throw this.#userNotLoggedInUserErrorFactory({
        message: `[DeleteAccountUserUseCase#execute] user not logged`
      }).toJSON()
    }

    const [repositoryError] = await this.#httpUserRepository.deleteUserAccount({userEntity})
    if (repositoryError) {
      return Promise.reject(repositoryError)
    }
  }

  static create({config}) {
    return new DeleteAccountUserUseCase({
      httpUserRepository: UserRepositoriesFactory.httpUserRepository({config}),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      userNotLoggedInUserErrorFactory: UserErrorsFactory.userNotLoggedInUserError
    })
  }
}

export const factory = DeleteAccountUserUseCase.create
